import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.37109 0H13.0581L19.2501 6.168V20.625C19.2501 20.8059 19.2144 20.985 19.145 21.1521C19.0757 21.3192 18.9741 21.471 18.846 21.5987C18.7178 21.7264 18.5658 21.8276 18.3985 21.8965C18.2312 21.9653 18.052 22.0005 17.8711 22H1.37109C1.00642 22 0.656683 21.8551 0.398821 21.5973C0.140958 21.3394 -0.00390625 20.9897 -0.00390625 20.625V1.375C-0.00390625 1.01033 0.140958 0.660591 0.398821 0.402728C0.656683 0.144866 1.00642 0 1.37109 0V0Z"
        fill="#C2C2C2"
      />
      <path
        d="M19.2305 6.18804H14.4375C14.0728 6.18804 13.7231 6.04317 13.4652 5.78531C13.2074 5.52745 13.0625 5.17771 13.0625 4.81304V0.0140381L19.2305 6.18804Z"
        fill="#565656"
      />
    </svg>
  );
};

export default memo(Icon);
